import * as React from "react";
import { Link } from "@fluentui/react";
import { parseId } from "../../helpers/idHelper";
import { useAppAuthContext } from "../../hooks/useAppAuthContext";
import { azurePortalUrl } from "../../utils";

export interface AzureResourceGroupLinkProps {
  resourceId: string;
}

export const AzureResourceGroupLink = (
  { resourceId }: AzureResourceGroupLinkProps,
): JSX.Element => {
  const { domainName } = useAppAuthContext();
  const idComps = parseId(resourceId);
  const subscriptionId = decodeURIComponent(idComps?.subscriptionId || "");
  const resGroup = decodeURIComponent(idComps?.resourceGroup || "");

  return (
    <Link
      // eslint-disable-next-line max-len
      href={`${azurePortalUrl}/#@${domainName}/resource/subscriptions/${subscriptionId}/resourceGroups/${resGroup}/overview`}
      target="_blank"
    >
      {resGroup}
    </Link>
  );
};
